/* Custom sections use the global bundle. Theme-native sliders use vendor.min.js. */
(() => {
  if (window.SajadaSwiper) return;

  const source = document.currentScript;
  const scriptUrl = source && source.dataset.swiperScript;
  const styleUrl = source && source.dataset.swiperStyle;
  const consumerSelector = '[data-sajada-swiper]';
  let loading;
  let observer;

  function loadStyle() {
    if (!styleUrl) return Promise.resolve();
    const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .find((link) => link.href === new URL(styleUrl, document.baseURI).href);
    if (existing) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = styleUrl;
      link.onload = resolve;
      link.onerror = () => reject(new Error('Unable to load the slider stylesheet.'));
      // Keep theme styles later in the cascade, as with the original layout link.
      document.head.insertBefore(link, document.head.querySelector('link[rel="stylesheet"]'));
    });
  }

  function loadScript() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    return new Promise((resolve, reject) => {
      if (!scriptUrl) {
        reject(new Error('The slider asset URL is missing.'));
        return;
      }
      const absoluteUrl = new URL(scriptUrl, document.baseURI).href;
      const existing = Array.from(document.querySelectorAll('script[src]'))
        .find((script) => script.src === absoluteUrl);
      const script = existing || document.createElement('script');
      script.addEventListener('load', () => {
        if (window.Swiper) resolve(window.Swiper);
        else reject(new Error('The slider library did not initialize.'));
      }, { once: true });
      script.addEventListener('error', () => reject(new Error('Unable to load the slider library.')), { once: true });
      if (!existing) {
        script.src = scriptUrl;
        script.defer = true;
        script.async = false;
        document.head.appendChild(script);
      }
    });
  }

  function load() {
    if (!loading) {
      loading = Promise.all([loadStyle(), loadScript()]).then(() => {
        if (observer) observer.disconnect();
        document.dispatchEvent(new CustomEvent('sajada:swiper:ready'));
        return window.Swiper;
      });
    }
    return loading;
  }

  function reportFailure(error) {
    console.warn('[sajada-swiper]', error.message);
  }

  window.SajadaSwiper = {
    ready(callback) {
      if (typeof callback !== 'function') return load();
      return load().then(callback).catch(reportFailure);
    },
  };
  document.dispatchEvent(new CustomEvent('sajada:swiper:loader-ready'));

  function scan(root) {
    if (root.nodeType !== 1 && root !== document) return;
    if ((root.matches && root.matches(consumerSelector)) || root.querySelector(consumerSelector)) {
      load().catch(reportFailure);
    }
  }

  scan(document);
  // Section Rendering API, cart redraws, and theme-editor insertions may add consumers later.
  observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach(scan));
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
